import { RequestDto } from "@/types/request";
import { blue } from "@/utils/Colors";
import { ListItem, ListItemButton } from "@mui/material";
import ListItemText from "@mui/material/ListItemText";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

interface NavItemLvlThreeProps {
  request: RequestDto;
  projectId: string;
}
export default function NavItemLvlThree(props: Readonly<NavItemLvlThreeProps>) {
  const navigate = useNavigate();
  const location = useLocation();
  const [hovered, setHovered] = useState(false);

  const shouldBeHighlighted = location.pathname.includes(props.request.id);

  return (
    <ListItem disablePadding sx={{ display: "flex" }}>
      <ListItemButton
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        sx={{
          display: "flex",
          flexDirection: "row",
          borderRadius: 1,
          paddingX: 1,
          paddingY: 0.5,
          ...(shouldBeHighlighted
            ? {
                backgroundColor: blue[200],
                color: blue[800],
              }
            : {
                color: blue[400],
              }),
          "&:hover": { backgroundColor: blue[300] },
        }}
        onClick={() =>
          navigate(
            `/project/${props.projectId}/request/${props.request.id}/false`
          )
        }
      >
        <ListItemText
          primary={props.request.name}
          sx={{ margin: 0 }}
          primaryTypographyProps={{
            variant: "subtitle1",
            sx: {
              whiteSpace: "nowrap",
              overflowX: "hidden",
              textOverflow: "ellipsis",
              color: blue[400],
              ...(shouldBeHighlighted && {
                color: blue[800],
              }),
              ...(hovered && {
                color: blue[600],
              }),
            },
          }}
        />
      </ListItemButton>
    </ListItem>
  );
}
